export enum QuoteActionType {
  ConvertToDepositInvoice = 'convertToDepositInvoice',
  ConvertToFinalInvoice = 'convertToFinalInvoice',
  ConvertToInvoice = 'convertToInvoice',
  Delete = 'delete',
  Duplicate = 'duplicate',
  Edit = 'edit',
  MarkAsSent = 'markAsSent',
  MarkAsUnsent = 'markAsUnsent',
  SendByEmail = 'sendByEmail',
  Share = 'share',
}
